import { getQuillHTML, setQuillHTML } from "#/shared/lib/quill-html";

import "#legacy/admin/page_builder/tool.js";
import "#legacy/admin/page_builder/wysiwyg/namespace.js";
import "#legacy/admin/page_builder/wysiwyg/blots.js";
import "#legacy/admin/page_builder/wysiwyg/modules/index.js";
import "#legacy/admin/page_builder/wysiwyg/tooltips.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function (Wysiwyg, Event, deepCopy, TelephoneTooltip, LinkTooltip, SmartTooltip) {
  "use strict";

  // Theme
  var SnowTheme = Quill.import("themes/snow");

  class SparkleTheme extends SnowTheme {}

  SparkleTheme.prototype.extendToolbar = function (toolbar) {
    toolbar.container.classList.add("ql-snow");
    this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")));
    this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")));

    if (toolbar.container.querySelector(".ql-link")) {
      this.linkTooltip = new LinkTooltip(this.quill);
      this.quill.keyboard.addBinding({ key: "k", shortKey: true }, function (range, context) {
        toolbar.handlers.link.call(toolbar, !context.format.link);
      });
    }

    if (toolbar.container.querySelector(".ql-telephone")) {
      this.telephoneTooltip = new TelephoneTooltip(this.quill);
    }

    if (toolbar.container.querySelector(".ql-snippet")) {
      this.smartTooltip = new SmartTooltip(this.quill);
    }
  };

  SparkleTheme.prototype.buildButtons = function (buttons) {};

  SparkleTheme.DEFAULTS = SnowTheme.DEFAULTS;
  SparkleTheme.DEFAULTS.modules.toolbar.handlers.telephone = function (value) {
    if (value) {
      var savedRange = this.quill.selection.savedRange;
      this.quill.theme.telephoneTooltip.open(savedRange);
    } else {
      this.quill.format("telephone", false);
    }
  };

  SparkleTheme.DEFAULTS.modules.toolbar.handlers.link = function (value) {
    if (value) {
      var savedRange = this.quill.selection.savedRange;
      this.quill.theme.linkTooltip.open(savedRange);
    } else {
      this.quill.format("link", false);
    }
  };

  SparkleTheme.DEFAULTS.modules.toolbar.handlers.snippet = function (value) {
    if (value) {
      var savedRange = this.quill.selection.savedRange;
      this.quill.theme.smartTooltip.open(savedRange);
    } else {
      this.quill.format("snippet", false);
    }
  };

  Quill.register(
    {
      "themes/sparkle": SparkleTheme,
      "modules/modal-view": function (quill, options) {
        var $button = jQuery(options.button).on("click", function (e) {
          var dialog = new Sparkle.PageBuilder.WysiwygDialog(options.tool, function (tool) {
            var context = deepCopy(tool.component.context);
            options.tool.setState(context);
            options.tool.update(options.tool.element, context);
          });
          e.preventDefault();
        });
      },
    },
    true,
  );

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "wysiwyg-editor",

    /**
     * @description The template file to use to load and render the component.
     * @see wysiwyg-editor-template.hbs
     */
    templateId: "wysiwyg-editor-template",

    // flag to keep track of when the wysiwyg content is changing just because
    // of the initial load. we don't want to save changes at this point, only want
    // to save user initiated changes.
    // this is because there are many ways that even just setting the wysiwyg content
    // could change the value: the quill blots set attributes also we transform the
    // content in various ways in setContent so it renders properly, and we might forget
    // to undo those changes in getContent.
    initialLoad: true,

    /**
     * @name update
     * @description
     * Manipulate the context of this element so that it always perpetuates in
     *  the correct state.
     * @param {HTMLElement} element
     * @param {object} context
     */
    update: function (element, context) {
      if (!this.editor) {
        return;
      }

      // update the editor with the new component context
      // set it to empty string first, because if you set content
      // that starts with a url into a container that already contains content
      // quill adds it to the end, instead of resetting the content.
      this.setContent("");
      this.setContent(context);

      var range = this.editor.getSelection();
      if (range) {
        this.editor.setSelection(range.start, range.end);
      }
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     * @param {HTMLElement} target
     */
    bind: function (component) {
      var me = this;
      var $toolContainer = jQuery(this.element).find(".tool-field");

      var attributeConfig = this.component.config.attributes[this.component.name] || {};

      if (this.config.wysiwyg_spacing) {
        $toolContainer[0].dataset.wysiwygSpacing = this.config.wysiwyg_spacing;
      }

      var toolsetOptions = "extended modalView";
      if (attributeConfig.show_no_break_format) {
        toolsetOptions += " noBreakFormat";
      }

      jQuery(Wysiwyg.render(toolsetOptions)).appendTo($toolContainer);

      var $editorElement = $toolContainer.find(".editor");
      var $toolbarElement = $toolContainer.find(".toolbar");
      var $modalElement = $toolContainer.find(".modal-view");

      var attributeConfig = this.component.config.attributes[this.component.name] || {};
      var placeholder = attributeConfig.placeholder;

      // setup options of new quill editor
      var opts = {
        modules: {
          toolbar: { container: $toolbarElement.get(0) },
          "modal-view": {
            button: $modalElement[0],
            tool: this,
          },
        },
        theme: "sparkle",
        placeholder: placeholder,
      };

      // instantiate the editor, and tie in the event to update the component
      //  and rerender it when there is a change in the editor.
      this.editor = Wysiwyg.initialize($editorElement[0], opts);
      this.editor.on(
        "text-change",
        function () {
          if (this.initialLoad) {
            return;
          }
          var newContent = this.getContent();
          if (newContent !== component.context) {
            component.save(this.getContent());
            component.render();
          }
        }.bind(this),
      );

      this.editor.on(
        "selection-change",
        function (range, oldRange, source) {
          var inputElement = this.$editorElement.closest(".input-well");
          if (range) {
            inputElement.addClass("editor-focused");
          } else {
            inputElement.removeClass("editor-focused");
          }
        }.bind(this),
      );

      this.$editorElement = $editorElement.find(".ql-editor");
      this.setContent(component.context);
      this.initialLoad = false;
    },

    /**
     * @name unbind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function () {
      if (!this.editor) {
        return;
      }

      delete this.editor;
    },

    setContent: function (html) {
      setQuillHTML(this.editor, html);
    },

    // An empty editor returns "", so elements hidden when there is no content (e.g. image captions) stay hidden.
    getContent: function () {
      return getQuillHTML(this.editor);
    },
  });
})(
  Sparkle.Components.Wysiwyg,
  Sparkle.PageBuilder.Helpers.Event,
  Sparkle.PageBuilder.Helpers.deepCopy,
  Sparkle.PageBuilder.Wysiwyg.Tooltips.TelephoneTooltip,
  Sparkle.PageBuilder.Wysiwyg.Tooltips.LinkTooltip,
  Sparkle.PageBuilder.Wysiwyg.Tooltips.SmartTooltip,
);
